import { API_BASE_URL } from '../../../../lib/api';

import { apiFetch } from '@/lib/apiFetch';
import { withTenant } from '../../../../lib/tenantHeaders';

const JSON_HEADERS = withTenant({ 'Content-Type': 'application/json' });

const LOGO_ACCEPT = '.png,.jpg,.jpeg,.gif,.webp,.svg';
const LOGO_MAX_SIZE_MB = 5;

export const fetchTenantSettings = async () => {
  const res = await apiFetch(`${API_BASE_URL}/tenant-settings`, { headers: withTenant() });
  return res.json();
};

export const updateTenantSettings = async (data) => {
  const res = await apiFetch(`${API_BASE_URL}/tenant-settings`, {
    method: 'PUT',
    headers: JSON_HEADERS,
    body: JSON.stringify(data),
  });
  return res.json();
};

// ---------- Logo (R2 presigned URL) ----------

export const getLogoUploadUrl = async ({ fileName, mimeType, size }) => {
  const res = await apiFetch(`${API_BASE_URL}/tenant-settings/logo/upload-url`, {
    method: 'POST',
    headers: JSON_HEADERS,
    body: JSON.stringify({ fileName, mimeType, size }),
  });
  return res.json();
};

export const confirmLogoUpload = async ({ key, fileName, mimeType, size }) => {
  const res = await apiFetch(`${API_BASE_URL}/tenant-settings/logo/upload-complete`, {
    method: 'POST',
    headers: JSON_HEADERS,
    body: JSON.stringify({ key, fileName, mimeType, size }),
  });
  return res.json();
};

export const deleteLogo = async () => {
  const res = await apiFetch(`${API_BASE_URL}/tenant-settings/logo`, {
    method: 'DELETE',
    headers: withTenant(),
  });
  return res.json();
};

/**
 * Sube el logo a R2 con presigned URL.
 * 1) pide URL firmada, 2) PUT directo a R2, 3) confirma al backend.
 */
export const uploadLogoToR2 = async (file, { onProgress } = {}) => {
  const urlRes = await getLogoUploadUrl({
    fileName: file.name,
    mimeType: file.type || 'application/octet-stream',
    size: file.size,
  });
  if (!urlRes?.success) {
    throw new Error(urlRes?.message || 'No se pudo obtener la URL de subida del logo');
  }
  const { uploadUrl, key } = urlRes.data;

  await new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('PUT', uploadUrl);
    xhr.setRequestHeader('Content-Type', file.type || 'application/octet-stream');
    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable && onProgress) {
        onProgress(Math.round((e.loaded / e.total) * 100));
      }
    };
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) resolve();
      else reject(new Error(`R2 respondiÃ³ ${xhr.status}: ${xhr.responseText}`));
    };
    xhr.onerror = () => reject(new Error('Error de red subiendo el logo a R2'));
    xhr.send(file);
  });

  const confirmRes = await confirmLogoUpload({
    key,
    fileName: file.name,
    mimeType: file.type || 'application/octet-stream',
    size: file.size,
  });
  return confirmRes;
};

export const LOGO_LIMITS = {
  accept: LOGO_ACCEPT,
  maxSizeMB: LOGO_MAX_SIZE_MB,
};
